module.exports = __webpack_public_path__ + "assets/45fd2c1c24e10e29d0262203769e8d07.mp4";